import React, { useState, useEffect } from 'react';
import './TextMasker.css';
import { maskText } from '../utils/maskingUtils';

const TextMasker = () => {
  const [originalText, setOriginalText] = useState('');
  const [maskedText, setMaskedText] = useState('');

  // Update masked text whenever original text changes
  useEffect(() => {
    setMaskedText(maskText(originalText));
  }, [originalText]);

  const handleCopyMasked = () => {
    navigator.clipboard.writeText(maskedText)
      .then(() => {
        alert('Masked text copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  };

  const handleClearText = () => {
    setOriginalText('');
    setMaskedText('');
  };

  return (
    <div className="text-masker">
      <div className="text-container">
        <h2>Original Text</h2>
        <textarea
          value={originalText}
          onChange={(e) => setOriginalText(e.target.value)}
          placeholder="Paste your original text here. It may contain sensitive information like emails, phone numbers, addresses, etc."
          rows={10}
        />
      </div>
      
      <div className="text-container">
        <h2>Masked Text</h2>
        <textarea
          value={maskedText}
          readOnly
          placeholder="Your masked text will appear here..."
          rows={10}
        />
        <div className="button-group">
          <button onClick={handleCopyMasked} disabled={!maskedText}>
            Copy Masked Text
          </button>
          <button onClick={handleClearText} disabled={!originalText}>
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
};

export default TextMasker;
